<template>
  <div class="row col-md-12 reduzirFonte" v-if="pessoaFisica">
    <div class="form-group col-md-12 col-lg-12 col-xl-6">
      <label for="cpf" class="required">CPF</label>
      <input type="text" v-mask="mascaraCpf" v-model="formulario.informacoes.pessoais.cpf_cnpj" :disabled="desabilitar" class="form-control" id="cpf">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.cpf_cnpj}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-6 col-xl-6">
      <label for="nome" class="required">Nome</label>
      <input type="text" v-model="formulario.informacoes.pessoais.nome" :disabled="desabilitar" class="form-control" id="nome">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.nome}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-6 col-xl-6">
      <label for="apelido">Apelido</label>
      <input type="text" v-model="formulario.informacoes.pessoais.nome_fantasia" :disabled="desabilitar" class="form-control" id="apelido">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.nome_fantasia}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-6">
      <label for="rg">RG (Registro Geral)</label>
      <input type="text" v-model="formulario.informacoes.pessoais.rg" :disabled="desabilitar" class="form-control" id="rg">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.rg}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-12">
      <label for="data_nascimento">Data Nascimento</label>
      <Datefield v-model="formulario.informacoes.pessoais.data_nascimento" :classField="'form-control'" :disabled="desabilitar" id="data_nascimento"/>
      <div class="avisoDanger text-left mt-1">{{listaDeErros.data_nascimento}}</div>
    </div>
  </div>
</template>
<script>
import mascaras from '@/util/mascaras'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import { mapState } from 'vuex'

export default {
  name: 'informacoes-pessoais',
  props: {
    pessoaFisica: {
      type: Boolean,
      default: false
    },
    desabilitar: {
      type: Boolean,
      default: false
    },
    listaDeErros: {
      type: [Array, Object],
      default: () => []
    }
  },
  components: {
    Datefield
  },
  computed: {
    ...mapState('escritorios', ['formulario']),
    mascaraCpf () {
      return mascaras.mascarasParaCampos.cpf
    }
  },
  data: () => {
    return {
    }
  },
  methods: {
  }
}
</script>
